/* eslint-disable */
// VARIABLES
var firstFocusClass = 'a11y-modal-first-focus';
var lastFocusClass = 'a11y-modal-last-focus';
var modal = document.querySelectorAll('.a11y-modal');
var body = document.body;
var focusElements = 'button:not([hidden]):not([disabled]), [href]:not([hidden]), input:not([hidden]):not([type="hidden"]):not([disabled]), select:not([hidden]):not([disabled]), textarea:not([hidden]):not([disabled]), [tabindex="0"]:not([hidden]):not([disabled]), summary:not([hidden]), [contenteditable]:not([hidden]), audio[controls]:not([hidden]), video[controls]:not([hidden])';
var initialTrigger;
var activeModal;
var firstFocus;
var lastFocus;
var videoIframe = document.querySelector('#player');
var videoSrc;
if (videoIframe) {
videoSrc = videoIframe.src;
}
// Setup
setupModal = function () {
    for (var i = 0; i < modal.length; i++) {
        var thisModal = modal[i];
        var thisModalId = thisModal.getAttribute('id');
        var thisHeading = thisModal.querySelector('h2:first-of-type');
        var focusable = thisModal.querySelectorAll(focusElements);

        thisHeading.id = thisModalId + '_heading';
        thisHeadingId = thisHeading.getAttribute('id');

        thisModal.setAttribute('role', 'dialog');
        thisModal.hidden = true;
        thisModal.setAttribute('aria-labelledby', thisHeadingId);

        setupClose(thisModal);

        focusable[0].classList.add(firstFocusClass);
        focusable[focusable.length - 1].classList.add(lastFocusClass);
    }
};

setupTrigger = function () {
    var modalTrigger = document.querySelectorAll('.a11y-modal-trigger');
    var thisTrigger;

    for (var i = 0; i < modalTrigger.length; i++) {
        thisTrigger = modalTrigger[i];
        var getTarget = thisTrigger.getAttribute('data-target');
        thisTrigger.id = getTarget + '_trigger-' + thisTrigger.nodeName;
        thisTrigger.addEventListener('click', openModal);
        thisTrigger.addEventListener('keydown', keyEvents, false);
    }
};

setupClose = function (thisModal) {
    var modalClose = thisModal.querySelectorAll('.a11y-modal .a11y-modal-close');

    for (var i = 0; i < modalClose.length; i++) {
        modalClose[i].setAttribute('aria-label', 'Close');
        modalClose[i].addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', keyEvents, false);
};

// Move modal as first child of body
moveModal = function () {
    var firstEl = body.firstElementChild || null;

    for (var i = 0; i < modal.length; i++) {
        body.insertBefore(modal[i], firstEl);
    }

    // Insert modal overlay
    body.insertAdjacentHTML('beforeend', '<div class="a11y-modal-overlay"></div>');
};

/**
 * Open modal
 * Trigger opens modal with matching id
 * Add a11y-modal-open class
 * Set aria-hidden=false to modal
 * Body content gets aria-hidden=true
 * Overlay underneath modal
 * Set focus to close button
 */

openModal = function () {
    var targetModal = this.getAttribute('data-target');
    activeModal = document.getElementById(targetModal);
    var focusTarget = activeModal.querySelector('.a11y-modal-close');
    initialTrigger = this.id;
    var bodyChildren = document.querySelectorAll('body > *:not(.a11y-modal)');

    if (!body.classList.contains('a11y-modal-open')) {
        body.classList.add('a11y-modal-open');
        for ( var i = 0; i < bodyChildren.length; i++ ) {
            bodyChildren[i].setAttribute('aria-hidden', 'true');
        }
    }
    activeModal.removeAttribute('hidden');
    focusTarget.focus();

    document.addEventListener('click', outsideClose, false);
    document.addEventListener('touchend', outsideClose, false);

    return [initialTrigger, activeModal];
}; // openModal

/**
 * Close modal
 * Remove a11y-modal-open class
 * Set modal to aria-hidden=true
 * Set body content to aria-hidden=false
 * Remove overlay
 * Set focus back to trigger with matching id
 */

closeModal = function () {
    var trigger = document.getElementById(initialTrigger);
    var bodyChildren = document.querySelectorAll('body > *:not(.a11y-modal)');

    for ( var i = 0; i < bodyChildren.length; i++ ) {
        bodyChildren[i].setAttribute('aria-hidden', 'false');
    }
    if (videoIframe) {
        videoIframe.src = videoSrc;
    }
    body.classList.remove('a11y-modal-open');
    trigger.focus();
    // Reset values
    initialTrigger = undefined;
    activeModal = undefined;

    return [initialTrigger, activeModal];
}; // closeModal

/**
 * Click outside modal to close
 */

outsideClose = function (e) {
    if (body.classList.contains('a11y-modal-open') && !e.target.classList.contains('a11y-modal-trigger')) {
        var isClickInside = activeModal.contains(e.target);
        if (!isClickInside) {
            var videoFrame = document.querySelector('#player');
            if (videoFrame) {
            videoFrame.src = '';
            }
            closeModal();
        }
    }
};

/**
 * Keyboard controls
 * Tab focus remains within modal when open
 * ESC closes the modal
 */

keyEvents = function (e) {
    var keyCode = e.keyCode || e.which;
    var keys = {
        esc: 27,
        enter: 13,
        space: 32,
        tab: 9,
    };

    if (e.target.classList.contains('a11y-modal-trigger')) {
        switch (keyCode) {
            case keys.enter:
            case keys.space:
                e.preventDefault();
                e.target.click();
                break;
            default:
                break;
        }
    }

    if (body.classList.contains('a11y-modal-open')) {
        switch (keyCode) {
            case keys.esc:
                closeModal();
                break;
            default:
                break;
        }

        if (body.classList.contains('a11y-modal-open')) {
            // Get first and last focusable elements
            firstFocus = $(activeModal)[0].getElementsByClassName(firstFocusClass)[0];
            lastFocus = $(activeModal)[0].getElementsByClassName(lastFocusClass)[0];
        }

        if (document.activeElement.classList.contains(lastFocusClass)) {
            if (keyCode === keys.tab && !e.shiftKey) {
                e.preventDefault();
                $(firstFocus).focus();
            }
        }

        if (document.activeElement.classList.contains(firstFocusClass)) {
            if (keyCode === keys.tab && e.shiftKey) {
                e.preventDefault();
                $(lastFocus).focus();
            }
        }
    }
}; // keyEvents

// Initialize Function
initModal = function () {
    moveModal();
    setupModal();
    setupTrigger();
};

// Go
initModal();


// WEBPACK FOOTER //
// ./scripts/partials/component-modal.js